import React from "react";
import Collapsible from "react-collapsible";
import "../../styles/uploadimage.css";
import "../../styles/static-content.css";


export default class PrivacyPolicy extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    PRIVACY AND DATA POLICY
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 ConfirmBuyRequest">


                                <div className="col-md-12">


                                    <p className="static-text-inside mb-5">

                                        At YourMasterpieces, we value the trust you place in us and insist upon the
                                        highest standards for security of transactions and privacy of your
                                        information. Please feel free to contact us at <a className="link" href="mailto:contact@yourmasterpieces.com">
                                            contact@yourmasterpieces.com
                                        </a>
                                         &nbsp; If you have any questions or suggestions regarding our  Privacy
                                        and Data Policy .

                                    </p>


                                    <Collapsible trigger="1. General">
                                        <p className="static-text-inside">
                                            <ul>
                                                <li>
                                                YourMasterpieces PTE. LTD. ("YourMasterpieces", together with "we", "us", and "our")
                                                    is
                                                    committed to the protection of personal information provided by
                                                    users to
                                                    YourMasterpieces through its services (henceforth referred to as
                                                    ''Service” or
                                                    ''Services”) through its website <a className="link"
                                                                                        href="https://www.yourmasterpieces.com">
                                                    www.yourmasterpieces.com </a>
                                                    (“Site”) and mobile applications (“Apps”) on iOS and Android. Users
                                                    agree that
                                                    the use of the Services implies consent to the collection, retention
                                                    and use of
                                                    users’ personal information in accordance with the terms in this
                                                    <a
                                                        href="https://www.yourmasterpieces.com/privacy-and-data-policy"
                                                        className="link"> Privacy
                                                        and Policy </a>.
                                                    If you do not want us to collect or process your personal
                                                    information in the ways
                                                    as described in this policy, you should not use the Services.
                                                </li>

                                            </ul>
                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="2. Information collected ">
                                        <p className="static-text-inside">
                                            <ul>
                                                In order to provide Services, YourMasterpieces tracks and collects the
                                                following categories of information when a User logs in or registers
                                                with any Service.

                                                <b className="font-big">a. Information Collected Automatically and
                                                    Analytics:</b>

                                                YourMasterpieces automatically receives and records information from
                                                your browser or your mobile device when you visit the Site or use the
                                                Apps, such as your IP address or unique device identifier, cookies, and
                                                data about which pages you visit and how you interact with those pages
                                                in order to allow us to operate and provide the Services. This
                                                information is stored in log files and is collected automatically. User
                                                logs are generated using Amazon Web Services (AWS) and Google Analytics
                                                (GA) and are described in depth in the following sections.

                                                Any identifying data or personal information shared by the users during
                                                registration is not shared with any third-party applications by
                                                YourMasterpieces, except in conditions as stated in Section 5.

                                                <b className="font-small-static">I. Third Party Analytics</b>
                                                Google Analytics (GA) is used to track and analyze all user traffic on
                                                our Site and Apps. This information is automatically generated and uses
                                                non-identifying data and tracks using the IP Address and user logs. This
                                                information is shared with GA and is a non-identifying field of
                                                information which is used by us to improve and enhance the user
                                                experience on our Services.
                                                <b className="font-small-static"> II. Web Service Provider Analytics</b>
                                                YourMasterpieces uses Amazon Web Services (AWS) as its web service
                                                provider. AWS is used to generate the user logs of all registered users
                                                and thus tracks the IP address and location of users who have
                                                registered. This information is a non-identifying field of information
                                                that is shared with AWS. YourMasterpieces uses this information to track
                                                the user activity and improve and enhance the user experience on our
                                                Services.
                                                <b className="font-big">b. User registration</b>
                                                When a User registers with YourMasterpieces, we collect few fields of
                                                information as a mandatory requirement, and some fields of information
                                                that the user has the option of providing for better personalization of
                                                Services.
                                                <b className="font-small-static">I. Facebook and Google Login:</b>
                                                Users can sign in using their Facebook account or their google account
                                                for creating an account for use with YourMasterpieces. When a User uses
                                                their Facebook or Google profile to log-in with YourMasterpieces,
                                                YourMasterpieces gets access to the user’s name, email, and profile
                                                picture. All other required or optional fields of information are asked
                                                from the user separately during registration.
                                                <b className="font-small-static"> II. Required Information:</b>
                                                In order to use the Services, the User needs to provide us with a valid
                                                email address, a name associated with the account, a username, primary
                                                country of location, a communication email (if it is different from the
                                                email associated with the account), and user’s gender and date of birth.
                                                All the aforementioned fields of information are required for the
                                                Services to function smoothly and without hindrances to the Users on the
                                                platform. For minors under the age of 18 and above the age of 13, an
                                                additional field of information – the legal guardian’s email address –
                                                will be required during registration. The username and country of
                                                location will be displayed publicly on the profile for the users. The
                                                remaining fields of information will not be available to any third
                                                party.
                                                <b className="font-small-static">III. Optional Information</b>
                                                The Users may provide additional optional fields of information to
                                                tailor their experience from the Services. This includes their interests
                                                and preferences (in specific styles, media, and whether they are buying
                                                or selling artworks), the city they are located in primarily, whether or
                                                not an artist wants to take commissioned work for customized artworks,
                                                and their bio, in which they can mention their story and inspirations.
                                                <b className="font-big">c. Payment Information</b>

                                                YourMasterpieces uses services provided by PayPal as the payment gateway
                                                for all transactions. YourMasterpieces may ask the sellers for their
                                                online banking information for the proceeds of a transaction to be
                                                deposited in their account. YourMasterpieces will not ask for any credit
                                                card information or online banking information from the buyers. It is
                                                the responsibility of the buyers to ensure their payment is deposited in
                                                the bank account of YourMasterpieces during a transaction.

                                                The privacy policy and data collection policy of PayPal may apply when a
                                                user logs in for a transaction. YourMasterpieces has no control over
                                                this data collection and requests the users to review the Terms and
                                                Conditions and privacy policy of the third-party banking companies
                                                before use.

                                                <b className="font-big">d. Information collected for Delivery or Pickup
                                                    of Artworks</b>
                                                During the transaction process, YourMasterpieces may ask for the
                                                shipping address, confirmation of email address, contact number, and
                                                other fields that may be required for the completion of the transaction
                                                and the pickup or delivery of artworks. YourMasterpieces reserves the
                                                right to share this information with the third-party delivery companies
                                                that we partner with for the delivery or pickup of the artworks.
                                                Information transmitted to the third-party delivery partners is not
                                                under the purview of YourMasterpieces, and YourMasterpieces waives the
                                                responsibility of any disclosure of information through the
                                                third-parties. At no point will YourMasterpieces share confidential
                                                information regarding the online banking and payment with any
                                                third-party.



                                            </ul>
                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="3. Choice and control">
                                        <p className="static-text-inside">

                                            Users have the right to review and change any errors in their personal
                                            information available with YourMasterpieces. Any optional field of
                                            information provided by the user may be removed if the user wishes to do so.
                                            If the user is unable to do so through their profile, they must contact
                                            YourMasterpieces at {` `}
                                            <a href="mailto:contact@yourmasterpieces.com" className="link">
                                                contact@yourmasterpieces.com</a> {` `}for assistance.
                                            YourMasterpieces reserves the right to deny the removal of any information
                                            from its systems if the user is in the middle of a transaction process.
                                            <br/>

                                            A user may request YourMasterpieces in writing that YourMasterpieces cease
                                            to use of their personal information, including the required fields for use
                                            of the Services. YourMasterpieces may stop providing services to such a
                                            user, if so required, and remove the information from its systems.<br/>


                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="4. Communication">
                                        <p className="static-text-inside">

                                            All users will receive communication emails from YourMasterpieces on the
                                            communication email provided during registration. These emails may include
                                            newsletters, marketing and promotional emails, information that may be of
                                            interest for you, announcements regarding the updates to the product and
                                            Services, and communication regarding art buy requests, the transaction
                                            process and reviewing the satisfaction with the delivery of artworks. At any
                                            point in time, users may unsubscribe to the mailing list for newsletters,
                                            marketing and promotional material, and announcements. This can be done via
                                            the unsubscribe button on the bottom of the emails or through the ‘My
                                            Account’ section on the Services. If you have any issues with these, you can
                                            mail us directly at <a href="mailto:contact@yourmasterpieces.com"
                                                                   className="link">
                                            contact@yourmasterpieces.com</a> for assistance.
                                            <br/>
                                            Unsubscribing from emails for updates to the Privacy and Data Policy or
                                           {` `} <a className="link" href="/terms-and-conditions">Terms and Condition </a> {` `} does not waive the user from being bound by them, and
                                            we require the user to review them after we have updated them before using
                                            the product or Services.
                                            <br/>
                                            Users may receive push notifications through the Apps and can control the
                                            notifications through their own mobile device settings.
                                            <br/>
                                            Users may not unsubscribe from the communication emails regarding art buy
                                            requests, the transaction process, or any other email sent by
                                            YourMasterpieces for clarification on information provided by us or
                                            announcements deemed essential by YourMasterpieces. If the users have any
                                            queries regarding the privacy and data policy or Terms and Conditions, they
                                            must email us at <a href="mailto:contact@yourmasterpieces.com"
                                                                className="link">
                                            contact@yourmasterpieces.com</a>.


                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="5. Confidentiality and Security">
                                        <p className="static-text-inside">
                                            No User information is rented or sold by YourMasterpieces to any third
                                            party.

                                            Except as stated otherwise in this Privacy and Data Policy, YourMasterpieces
                                            will keep all personal information private and will not share it with any
                                            third-parties, unless YourMasterpieces believes in good faith that
                                            disclosure of such personal information or any other information collected
                                            about users is necessary for permitted use, or to:
                                            <br/>
                                            <ul>
                                                <li>(a) Comply with a court order or other legal processes</li>
                                                <li>(b) Protect the rights, property, or safety of YourMasterpieces or
                                                    another party
                                                </li>
                                                <li>(c) Enforce the agreement, including {` `} <a className="link" href="/terms-and-conditions">Terms and Condition </a> { ` `} and Privacy and Data Policy; and/or</li>
                                                <li>(d) Respond to claims in relation to violation of the rights of
                                                    third-parties by YourMasterpieces
                                                </li>
                                            </ul>
                                            <b className="font-big">a. Account Security</b>
                                            All accounts registered with YourMasterpieces are protected by a password.
                                            Any user’s password is not shared by YourMasterpieces with any third-party.
                                            However, for safety of the account, we recommend the user to change their
                                            password at least once a year. Apart from that, we also recommend the user
                                            to ensure that their YourMasterpieces account passwords stored with any
                                            third-party applications are secured. YourMasterpieces waives any
                                            responsibility in the situation of a breach of account information or stolen
                                            passwords from any third-party application that the user may use for storing
                                            passwords. We also recommend to not have the passwords physically written on
                                            the device or on a note on the device to ensure safekeeping.
                                            YourMasterpieces will not be responsible for any account information stolen
                                            in such a situation.

                                            <b className="font-big">b. User Data Security</b>
                                            YourMasterpieces takes the security of user data extremely seriously. Any
                                            identifying information provided by the user is not shared with any
                                            third-party applications. YourMasterpieces takes all required measures to
                                            ensure that the safety and security of user data is not compromised. A high
                                            standard of security is maintained by YourMasterpieces for its users.
                                            However, the transmission of information via the internet and web networks
                                            is not completely secure. While YourMasterpieces does its best to protect
                                            users’ information, particularly with respect to protection of users’
                                            personal data, YourMasterpieces cannot ensure the security of users’ data
                                            transmitted via the internet, web network or any other networks.


                                            <b className="font-big">c. Artwork Data Protection</b>
                                            YourMasterpieces does not share artwork data with any third-party, except
                                            for promotional purposes. All artworks shared with YourMasterpieces are
                                            stored securely and are visible publicly to all users of the Services. When
                                            a user uploads, submits, stores or sends any content to or through the
                                            Services, the user gives YourMasterpieces including, YourMasterpieces’
                                            employees, agents, consultants, as the case may be, a worldwide license to
                                            use, copy, transmit, host, store, reproduce, modify, create derivative works
                                            of, communicate, publish, publicly perform, publicly display, print, edit,
                                            translate, reformat and distribute such content. The rights users grant in
                                            this license are for the limited purpose of operating, promoting, and
                                            improving the Services, and to develop new services. This license shall
                                            continue to operate even if a user stops using the Services. The user shall
                                            not hold YourMasterpieces accountable for the above in any court of law.
                                            YourMasterpieces will always declare the artwork as the artists’
                                            intellectual property.
                                            YourMasterpieces waives the liabilities of the duplication of artwork
                                            data should it take place via taking screenshots, pictures or downloading of
                                            images via the screens of its Services. YourMasterpieces also waives the
                                            responsibility of lost artwork data should it take place by a breach in data
                                            of a third-party who might have received the data from the artist, or
                                            through legitimate means from YourMasterpieces in compliance with this
                                            Privacy and Data Policy.

                                            <b className="font-big">d. Disclosure of Data Breach:</b>
                                            In the unfortunate event of unintended disclosures of personal information,
                                            if YourMasterpieces becomes aware that certain personal information has been
                                            disclosed in a manner not in accordance with this Privacy and Policy,
                                            YourMasterpieces will use reasonable efforts to notify the concerned user of
                                            the nature and extent of such disclosure (to the extent YourMasterpieces is
                                            aware of that information) as soon as reasonably possible and as permitted
                                            by law.


                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="6. Updates to Policy">
                                        <p className="static-text-inside">
                                            YourMasterpieces reserves the right, to add to, change, update, or modify
                                            this <a href="http://www.yourmasterpieces.com/privacy-and-data-policy" className="link">
                                            Privacy and Data Policy</a>. Users are requested to review this Privacy and
                                            Data Policy frequently. If any changes are incorporated in this 
                                            Privacy and
                                            Data Policy, YourMasterpieces will post such changes on this page.

                                        </p>

                                    </Collapsible>


                                </div>


                            </div>
                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/static/privacy-and-policy.js